import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Launch Readiness Report v1, C3 (2026-02) — a static Privacy Notice + Terms page for the NJM
 * Build Freelancer Portal launch. Body copy below is DELIBERATE PLACEHOLDER TEXT ONLY — the
 * founder is supplying the real legal copy separately; nothing here was auto-generated as
 * actual legal language. Public route (no auth), reachable pre- and post-login.
 */
const PLACEHOLDER_NOTICE = "[Placeholder — final legal copy pending from NJM. This section will be replaced before general launch.]";

const SECTIONS = {
  privacy: {
    label: "Privacy Notice",
    body: [
      "What information NJM Build collects (e.g. your Google account identity, profile details, portfolio, rate card, availability).",
      "How that information is used (e.g. assignment matching, project communication, payments).",
      "Who can see it (staff vs. other members) and how long it's kept.",
      "How to request a copy or deletion of your data.",
    ],
  },
  terms: {
    label: "Terms of Use",
    body: [
      "Your responsibilities as a member of the NJM Build community and platform.",
      "Acceptable use of the community feed ('The Floor') and project workflow tools.",
      "How assignments, rate cards, and payments are governed.",
      "How this agreement can change and how you'll be notified.",
    ],
  },
};

export default function LegalNotice() {
  const [active, setActive] = useState("privacy");
  const section = SECTIONS[active];

  return (
    <div className="min-h-screen bg-canvas px-4 py-10 sm:py-16" data-testid="legal-notice-page">
      <div className="mx-auto max-w-2xl">
        <Link to="/build/login" data-testid="legal-notice-back-link" className="inline-flex items-center gap-1.5 text-[11px] text-faint hover:text-ink transition-colors">
          <ArrowLeft className="h-3 w-3" /> Back
        </Link>

        <h1 className="mt-6 text-2xl font-editorial text-ink">NJM Build — Privacy &amp; Terms</h1>

        <div className="mt-5 flex gap-1.5" role="tablist">
          {Object.entries(SECTIONS).map(([key, s]) => (
            <button
              key={key}
              onClick={() => setActive(key)}
              data-testid={`legal-notice-tab-${key}`}
              className={`rounded-full px-3.5 py-1.5 text-[11px] font-medium uppercase tracking-wider transition-colors ${
                active === key ? "bg-ink text-paper" : "bg-hairline text-ink-soft hover:text-ink"
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>

        <div className="mt-6 rounded-xl border border-hairline bg-white p-6 sm:p-8" data-testid={`legal-notice-content-${active}`}>
          <div className="mb-4 rounded-md border border-amber-300/60 bg-amber-50 px-3 py-2 text-[11px] text-amber-800" data-testid="legal-notice-placeholder-banner">
            {PLACEHOLDER_NOTICE}
          </div>
          <ul className="space-y-3 text-sm text-ink-soft leading-relaxed">
            {section.body.map((line, i) => (
              <li key={i} className="flex gap-2">
                <span className="text-faint">·</span>
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </div>

        <p className="mt-6 text-[11px] text-faint">
          Questions about this notice? Contact <a href="mailto:hello@njmpro.com" className="underline hover:text-ink">hello@njmpro.com</a>.
        </p>
      </div>
    </div>
  );
}
